<template>
  <Branding>
    <div id="pageBody" class="pageBody">
      <AppHeader />
      <div class="contentBody">
        <div class="leftMargin">&nbsp;</div>
        <slot />
        <div class="rightMargin">&nbsp;</div>
      </div>
      <AppFooter />
    </div>
  </Branding>
</template>

<script></script>

<style scoped>
.pageBody {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  flex-grow: 1;
  padding: 0;
  font-family: Roboto;
  color: var(--black);
  background-color: var(--gray50);
}

.contentBody {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0;
  align-self: stretch;
  margin: 0 0 60px;
  flex: 1;
}

.leftMargin {
  display: flex;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
}

.rightMargin {
  display: flex;
  order: 2;
  align-self: stretch;
  flex-grow: 1;
}

@media only screen and (max-width: 792px) {
  .layoutFooter {
    display: none;
  }

  .contentBody {
    margin: 0;
    flex-grow: 1;
  }
  .leftMargin {
    display: none;
  }

  .rightMargin {
    display: none;
  }
}
</style>

<style>
.gray600 {
  color: var(--gray600);
}

.gray400 {
  color: var(--gray400);
}
</style>
